import * as React from "react"

import AccordionButton from "./accordionButton"

const AccordionSection = props => {
  const [isHidden, setIsHidden] = React.useState(props.isHidden)

  const handleClick = () => {
    setIsHidden(!isHidden);

    (typeof window !== "undefined" && window.gtag) &&
      window.gtag("event", "Click", {
        event_category: "Accordion",
        event_label: `${props.title}`,
        non_interaction: true
      })
  }

  return (
    <>
      <dt>
        <AccordionButton
          title={props.title}
          onClick={handleClick}
          isHidden={isHidden}
        />
      </dt>
      <dd className={`pb-4 ${isHidden ? "is-hidden" : ""}`}>
        {props.children}
      </dd>
    </>
  )
}

export default AccordionSection
